$w.onReady(function () {
    console.log("114462343523546")
});
